import { Box, Button } from '@mui/material'
import { TermsCondition } from './TermsCondition'
import { Navbar } from '../../../components/Navbar'
import { Footer } from '../../../components/Footer'
import { PageContainer } from '../../../components/styled/PageContainer'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

export const TNGInstruction = () => {
  return (
    <Box>
      <Helmet>
        <title>Nexen Tire X Tng Campaign</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Box display='flex' justifyContent='center'>
          <img src={'/client-static/tngCampaign/NexenTnG.png'} width='100%' />
        </Box>
        <TermsCondition />
        <Box display='flex' justifyContent='center' alignItems='center' mb={10}>
          <Button fullWidth variant='contained' color='primary' style={{ textDecoration: 'none' }}>
            Campaign Ended
          </Button>
        </Box>
      </PageContainer>
      <Footer />
    </Box>
  )
}
